import React from 'react';

/**
 * Button
 *
 * Button component for automatic lists
 * Uses button attributes from data-button-styles, which are set in the editor
 *
 * @param {Object}  props
 * @param {Object}  props.loadMore
 * @param {boolean} props.loading
 */
const LoadMoreButton = ({ makeRequest, loading }) => {
  return (
    <div className={ `wp-block-dwt-button block__button pt-20 ${loading ? 'h-full' : ''}` }>
      <div className='button-wrapper'>
        <button
          className="btn--primary"
          disabled={ !!loading }
          onClick={ makeRequest }
        >
          { loading ? 'Loading...' : 'Load More' }
        </button>
      </div>
    </div>

  );
};

export default LoadMoreButton;
